import { render, staticRenderFns } from "./login-bottom.vue?vue&type=template&id=07433df8&scoped=true"
import script from "./login-bottom.vue?vue&type=script&lang=js"
export * from "./login-bottom.vue?vue&type=script&lang=js"
import style0 from "./login-bottom.vue?vue&type=style&index=0&id=07433df8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07433df8",
  null
  
)

export default component.exports